import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct;

export interface ProductDetailsInterchangesStyles {
    wrapper?: InjectableCss;
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
}

export const interchangesStyles: ProductDetailsInterchangesStyles = {
    wrapper: {
        css: css`
            margin: 30px 0;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    accordionSection: {
        titleTypographyProps: {
            transform: "uppercase",
            forwardAs: "h3",
            css: css`
                margin: 0;
            `,
        },
        panelProps: {
            css: css`
                padding: 0 10px 20px;
                border: 0;
            `,
        },
        mergeCss: true,
    },
};

const styles = interchangesStyles;

const ProductDetailsInterchanges: React.FC<OwnProps> = ({ product }) => {
    if (!product.properties.interchanges || product.properties.interchanges === "") {
        return null;
    }

    const formatInterchange = product.properties.interchanges.split(/[ ]+/).join(", ");

    return (
        <StyledWrapper {...styles.wrapper}>
            <Accordion {...styles.accordion} headingLevel={2}>
                <AccordionSection title={translate("Interchanges")} {...styles.accordionSection}>
                    {formatInterchange}
                </AccordionSection>
            </Accordion>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsInterchanges),
    definition: {
        displayName: "Interchanges",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
